import 'blueimp-gallery';
import 'blueimp-gallery/js/jquery.blueimp-gallery';

var start = function start() {};

export default {
  start: start
};